<template>
<body class="lg:px-20 px-4">
<div class="2xl:mx-auto lg:py-16 lg:px-20 md:py-12 md:px-6 py-9 px-4">
            <p class="font-normal text-sm leading-3 text-indigo-700 hover:text-indigo-800 cursor-pointer pb-2 text-left">About</p>
            <div class="flex lg:flex-row flex-col lg:gap-8 sm:gap-10 gap-12">
                <div class="w-full lg:w-6/12">
                    <h2 class="w-full font-bold lg:text-4xl text-3xl lg:leading-10 leading-9 text-left">We are a construction and fabrication company that deals in Aluminium, Wood and glass.</h2>
                    <p class="font-normal text-base leading-6 text-gray-600 mt-6 text-left">With over 10 years of experience Boss Aluminium is a well renowned name for Aluminium fabrication, Hardware and construction. We are second to none when it comes to quality aluminium products, Here at Boss Aluminium we believe in maintaining the highest internatonal standards at all times. We will not compromise on the trust of our clients.</p>
                </div>
                <div class="w-full lg:w-6/12 lg:-mt-8">
                    <img class="lg:block hidden w-full" src="https://i.ibb.co/cgYHb8s/1222.png" alt="people discussing on board" />
                    <img class="lg:hidden sm:block hidden w-full" src="https://i.ibb.co/cgYHb8s/1222.png" alt="people discussing on board" />
                    <img class="sm:hidden block w-full" src="https://i.ibb.co/QNqmFr2/122.png" alt="people discussing on board" />
                
                </div>
            </div>

           

<div class="mt-9 md:mt-11 lg:mt-16">
                    <div class="text-center">
                        <h1 class="text-3xl font-medium leading-loose text-gray-800">Meet our administrative members</h1>
                        <p class="mx-4 md:mx-0 mb-4 text-base leading-none text-gray-600 mt-4">Our team is just an email away and ready to answer your questions</p>
                    </div>
                    <div role="list" aria-label="Our Team mates" class="flex flex-wrap items-center justify-around mt-2">
                        <div role="listitem" class="focus:outline-none flex flex-col items-center justify-center m-6">
                            <img src="https://i.postimg.cc/85h6jPyw/prof.png" alt="Display avatar of julia john" role="img" />
                            <p class="text-base font-semibold leading-none text-gray-800 mt-2">Tarek</p>
                            <p class="text-base leading-none text-gray-600 mt-2">C.E.O</p>
                        </div>
                        <div role="listitem" class="focus:outline-none flex flex-col items-center justify-center m-6">
                            <img src="https://i.postimg.cc/85h6jPyw/prof.png" alt="Display avatar of Tom Koch" role="img" />
                            <p class="text-base font-semibold leading-none text-gray-800 mt-2">Ali</p>
                            <p class="text-base leading-none text-gray-600 mt-2">Director</p>
                        </div>
                        <div role="listitem" class="focus:outline-none flex flex-col items-center justify-center m-6">
                            <img src="https://i.postimg.cc/85h6jPyw/prof.png" alt="Display avatar of Kera Ann" role="img" />
                            <p class="text-base font-semibold leading-none text-gray-800 mt-2">Sianga</p>
                            <p class="text-base leading-none text-gray-600 mt-2">HR</p>
                        </div>
                        <div role="listitem" class="focus:outline-none flex flex-col items-center justify-center m-6">
                            <img src="https://i.postimg.cc/85h6jPyw/prof.png" alt="Display Avatar of Glenn Jo" role="img" />
                            <p class="text-base font-semibold leading-none text-gray-800 mt-2">Glenn Jo</p>
                            <p class="text-base leading-none text-gray-600 mt-2">Support</p>
                        </div>
                        <div role="listitem" class="focus:outline-none flex flex-col items-center justify-center m-6">
                            <img src="https://i.postimg.cc/RZLFb74T/anje.png" alt="Display avatar of Shing Co" role="img" />
                            <p class="text-base font-semibold leading-none text-gray-800 mt-2">Mrs Anjali</p>
                            <p class="text-base leading-none text-gray-600 mt-2">General Manager</p>
                        </div>
                    </div>
                    
                </div>
            </div>
</body>
        </template>
        <script>
export default {
  name: "About",
  data() {
    return {};
  },
};
</script> 

<style scoped>
</style>

        
   